<template>
  <section class="info" :id="carData.key">
      <h2 class="info__name">{{ carData.name }}</h2>

      <div v-if="carData.benefit" class="info__benefit" @click="getCall({ type: 'sale'})">
        <img src="@/images/icons/wallet.svg" alt="wallet" class="info__benefit--icon">
        <p v-if="carData.benefit === 'max'" class="info__benefit--text">
          Максимальные выгоды <br/> в этом месяце!
        </p>

        <p v-else class="info__benefit--text">
          Выгода до {{ carData.benefit }} ₽
        </p>
      </div>

      <div v-if="carData.payment" class="info__payment" @click="getCall({ type: 'sale' })">
        <img src="@/images/icons/wallet.svg" alt="wallet" class="info__payment--icon">
        <p class="info__payment--text">
          Платеж от {{ carData.payment }} ₽ / месяц<sup>*</sup>
        </p>
      </div>

      <car-bottom :bottomData="carData" @getCall="getCall" class="info__bottom" />
  </section>
</template>

<script>
import Mixin from "@/common/mixin";
import CarBottom from "./car-bottom.vue";

export default {
  name: "info",
  props: ["carData"],
  mixins: [Mixin],
  components: { CarBottom }
};
</script>

<style lang="scss" scoped>
@import "@/styles/constants.scss";

.info {
  display: flex;
  flex-direction: column;

  &__name {
    font-size: 2.7em;
    font-weight: 700;
    margin-bottom: 0.25em;
    text-transform: uppercase;
    white-space: nowrap;
    color: #000;
  }

  &__payment,
  &__benefit {
    display: flex;
    align-items: center;
    gap: 0.9em;
    padding: 0.35em 1.6em 0.35em;
    background: $primary;
    border-radius: 0 0.6em 0.6em 0;
    width: max-content;
    margin-left: -1.44em;
    margin-bottom: 0.23em;
    font-size: 1.7em;
    font-weight: 700;
    cursor: pointer;

    &--icon {
      max-width: 1.3em;
    }
  }

  &__benefit {
    background: #05145F;
  }

  &__payment {
    margin-bottom: 0.4em;
  }
}

@media (max-width: 800px) {
  .info {
    &__name {
      font-size: 2.4em;
      white-space: wrap;
    }
    
    &__payment,
    &__benefit  {
      margin-left: -0.6em;
      margin-bottom: 0.23em;
    }

    &__advantages {
      font-size: 1.1em;
    }

    &__bottom {
      display: none;
    }
  }
}
</style>
